import { SET_SLOT_SHOW } from "../actions";

export const slotReducer = (state = true, action) => {
  if (action.type === SET_SLOT_SHOW) {
    return action.payload;
  }
  return state;
};

export default slotReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/slotReducer.js